var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0207 24.2707H24.2707V23.0207V2.7428C26.2212 3.11025 30.7287 3.28109 32.4998 3.28109C34.2706 3.28109 38.7805 3.11031 40.729 2.74282V23.0207V24.2707H41.979H62.2569C61.8894 26.2212 61.7186 30.7287 61.7186 32.4998C61.7186 34.2706 61.8894 38.7805 62.2569 40.729H41.979H40.729V41.979V62.2569C38.7785 61.8894 34.271 61.7186 32.4998 61.7186C30.7287 61.7186 26.2212 61.8894 24.2707 62.2569V41.979V40.729H23.0207H2.7428C3.11025 38.7785 3.28109 34.271 3.28109 32.4998C3.28109 30.7287 3.11025 26.2212 2.7428 24.2707H23.0207Z",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.0c44bd87ed59bb8b4f6a6ecd40d99b52.svg";
export { ForwardRef as ReactComponent };